(() => {
    class Favorite extends App.Component {
        constructor(container) {
            super(container);
            this.id = this.read('favorite-id', false);
            this.pill = this.container.querySelector('.pill.favorites-counter');
            App.Endpoint.Favorites.Observer.register(this); // Update all fav buttons when endpoint changes
            this.update();
            this.bind();
        }

        /* Constants */
        get Component() { return this.container.getComponent() }

        bind() {
            this.container.addEventListener('click', () => {
                // Only if user is logged in
                if (App.Interface.User.isLoggedIn()) {
                    App.execute('Button-Favorite', {
                        target: this,
                        id:     this.id,
                        active: this.Component.Toggle.active,
                        dialog: this.container.classList.contains('js-favorite-dialog'), // this will prompt a confirmation dialog
                        tempId: this.tempId, // todo: this should not be necessary if we only work with productId to delete
                    });
                } else {
                    this.Component.Toggle.active = false;
                    App.Components.Popup.showXMLHttpRequestContent(App.Route('login') + '?next=' + window.location);
                }
            });
        }

        renderPill() {
            if (this.pill) {
                let product = App.Endpoint.Products.getById(this.id);
                if (product) this.pill.innerHTML = product.likes;
            }
        }

        async update() {
            let fav = await App.Endpoint.Favorites.getByProduct(this.id);
            // todo: this should not be necessary if we only work with productId to delete
            if (fav !== undefined) this.tempId = fav.id;
            this.Component.Toggle.active = fav !== undefined;
            this.renderPill();
        }
    }
    App.Components.register('[data-favorite-id]', Favorite, 'Favorite');
})();
